
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7H20V10H2V7ZM11.1 17C11.0344 16.6769 11 16.3425 11 16C11 15.2889 11.1484 14.6125 11.416 14H2V17H11.1ZM19 11.4529C17.08 11.4529 15 11.9405 15 12.9532C15 13.9659 17.08 14.4535 19 14.4535C20.92 14.4535 23 13.9659 23 12.9532C23 11.9405 20.92 11.4529 19 11.4529ZM15 14.3035C15.92 14.9411 17.48 15.2037 19 15.2037C20.52 15.2037 22.08 14.9411 23 14.3035V15.9538C23 16.9665 20.92 17.4541 19 17.4541C17.08 17.4541 15 16.9665 15 15.9538V14.3035ZM15 17.3041C15.92 17.9417 17.48 18.2043 19 18.2043C20.52 18.2043 22.08 17.9417 23 17.3041V18.9544C23 19.9671 20.92 20.4547 19 20.4547C17.08 20.4547 15 19.9671 15 18.9544V17.3041Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowDataSourceAssignmentFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
